"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSkillToDeliverables = void 0;
exports.mapSkillToDeliverables = {
    'floorplan.1': ['floorplan'],
    'floorplan.3': ['floorplan'],
    'floorplan.5': ['floorplan'],
    'treesixty.1': ['tour360'],
    'treesixty.3': ['tour360'],
    'treesixty.5': ['tour360']
};
//# sourceMappingURL=mapSkillToDeliverables.js.map